<template>
    <section>
        <el-dialog class="close-private" :visible.sync="show" :title="$t('operations.turn_off.name')" width="30%"
            :close-on-click-modal="false" :before-close="handleClose">
            <p class="red-tip">{{ $t('game.list.closeRedTip') }}</p>
            <p>{{ $t('game.list.closeTip', [name]) }}</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelClose">{{ $t('privateNetInstance.cancel') }}</el-button>
                <el-button @click="sureClose" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
            </div>
        </el-dialog>
        <jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="OperationConstant.STOP" @success="onSuccess"
            @error="onError">
        </jcb-opt-protect>
    </section>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';
export default {
    name: "Close",
    mixins: [operationProtect],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        instanceId: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        },
        pageSource: {
            type: String,
            default: ''
        },
        rowInfo: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {
            show: false,
            // 操作保护弹框是否显示
            operationProtectVisible: false,
        }
    },
    computed: {
        OperationConstant: () => OperationConstant
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancelClose() {
            this.handleClose();
        },
        sureClose() {
            this.rowInfo.instanceType = "game";
            this.openOperationProtect(OperationConstant.STOP, this.rowInfo, this.pageSource);
            this.handleClose();
        },
        closeInstance(headers) {
            const params = {
                instanceId: this.rowInfo.instanceId,
                region: this.region,
                clientToken: Normal.getClientToken(),
            };
            Ajax.put('/api/cps/stopInstance', params, { headers })
                .then()
                .catch()
                .finally(() => {
                    this.handleClose();
                    this.$emit('refresh')
                });
        }
    }
}
</script>

<style lang="scss">
.close-private {}
.red-tip {
  color: #F52F3E;
  padding-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/game/Close.vue